import $ from 'jquery';
import readingTime from 'reading-time/lib/reading-time';

const $readingtime = $('.js-readingtime');
const $readingtimeText = $('.js-readingtime-text');

if ($readingtime.length) {
  const stats = readingTime($readingtimeText.text());
  $readingtime.text(`${Math.ceil(stats.minutes)} minute read`);
}
